// domain/storagefee.ts — Biaya Simpan unit telat diambil (SOP §3.6/§8.6).
// Ditagih ke pelanggan (baris terpisah di nota) sbg PENDAPATAN LAIN-LAIN — BUKAN omzet
// servis (tak menaikkan profit/komisi/KPI teknisi). Port biayaSimpanAmount/ReadyDays v0.18.
// Config = konstanta; pindah ke tabel settings saat modul Pengaturan dibangun.

export const BIAYA_SIMPAN_BULAN = 50000; // per bulan setelah 3 bln
export const AMBANG_BELUM = 30;          // hari: unit dianggap "belum diambil"
export const BIAYA_SIMPAN_ON = true;

/** Ambang waktu biaya-simpan (hari) — bisa di-setting di Pengaturan → SLA & Waktu.
 *  mulaiHari: fee mulai setelah N hari · lepasHari: >N hari lepas tanggung jawab (fee 0) · intervalHari: +1 bulan tiap N hari. */
export interface StorageThresholds { mulaiHari: number; lepasHari: number; intervalHari: number }
export const DEFAULT_STORAGE_THR: StorageThresholds = { mulaiHari: 90, lepasHari: 180, intervalHari: 30 };

/** Hari sejak unit MASUK status Siap Diambil (basis fee). */
export function readyDaysSince(siapISO: string | null | undefined): number {
  if (!siapISO) return 0;
  const ms = new Date(siapISO).getTime();
  if (isNaN(ms)) return 0;
  return Math.max(0, Math.floor((Date.now() - ms) / 86400000));
}

/** Fee: mulai setelah `mulaiHari` (default 90 = 3 bln), +bulan tiap `intervalHari`; > `lepasHari` (default 180 = 6 bln) → 0 (lepas tanggung jawab).
 *  `bulan`/`on`/`thr` bisa di-override dari Pengaturan (default = konstanta lama = anti-regresi). */
export function storageFeeAmount(
  readyDays: number, bulan = BIAYA_SIMPAN_BULAN, on = BIAYA_SIMPAN_ON, thr: StorageThresholds = DEFAULT_STORAGE_THR,
): number {
  if (!on) return 0;
  const interval = thr.intervalHari > 0 ? thr.intervalHari : 30;
  if (readyDays <= thr.mulaiHari || readyDays > thr.lepasHari) return 0;
  return bulan * (Math.floor((readyDays - thr.mulaiHari) / interval) + 1);
}
